import {
  Cookiebanner,
  cookiebannerTemplateMinimal,
  cookiebannerLabels as defaultLabels,
} from '@3pc/cookiebanner';
import '../../../../node_modules/@3pc/cookiebanner/lib/style/cookiebanner.scss';
import { $, $$, setAttributes } from 'utils/dom';
import { Accordion } from '@3pc/accordion';
import { uniqueId } from 'utils/helper';

const isProduction = document.body.hasAttribute('data-production');
const siteId = document.body.getAttribute('data-trackingId');
const matomoSiteId = isProduction ? siteId : 10;
const matomoUrl = isProduction
  ? '//matomo-drogenbeauftragte-matomo.apps.public.bfarm.de/'
  : 'https://qa.linux15.3pc.de/matomo/';
const hideCookiebanner = document.body.hasAttribute('data-hide-cookiebanner');
const imprintLink =
  document.querySelector('[data-imprint-link]') &&
  JSON.parse(document.querySelector('[data-imprint-link]').dataset.imprintLink);
const privacyPolicyLink =
  document.querySelector('[data-privacy-policy-link]') &&
  JSON.parse(
    document.querySelector('[data-privacy-policy-link]').dataset
      .privacyPolicyLink
  );

const cookiebannerLabels = {
  ...defaultLabels,
  mainPanelTitle: {
    de: 'Unsere Cookie-Richtlinien',
    en: 'Your cookie settings',
  },
  mainPanelText: {
    de: '<p>Wir verwenden Cookies, um Ihnen ein optimales Website-Erlebnis zu bieten. Dazu zählen Cookies, die für den Betrieb der Seite notwendig sind, sowie solche, die lediglich zu anonymen Statistikzwecken, für Komforteinstellungen oder zur Anzeige personalisierter Inhalte genutzt werden. Bitte beachten Sie, dass nur Ihre Einwilligung sicherstellt, dass Ihnen alle Funktionalitäten der Seite zur Verfügung stehen. Ihre Einwilligung können Sie jederzeit in der Datenschutzerklärung widerrufen.</p>',
    en: '<p>We use cookies to give you the best possible website experience. These include cookies that are necessary for the operation of the site as well as those that are only used for anonymous statistical purposes, for comfort settings or to display personalized content. Please note that only your consent ensures that all functionalities of the site are available to you. You can revoke your consent at any time in the data protection declaration.</p>',
  },
  configPanelText: {
    de: '',
    en: '',
  },
};

// if (isProduction) {
new Cookiebanner({
  nameSpace: 'bdb',
  consentButtonTypes: 'required-all',
  cookiebannerTemplate: cookiebannerTemplateMinimal,
  showTemplateMinimalInfoPanel: true,
  labels: cookiebannerLabels,
  hideCookiebanner,
  imprintLink,
  privacyPolicyLink,
  consentTypes: [
    {
      name: {
        de: 'Technische Cookies',
        en: 'Essential Cookies',
      },
      text: {
        de: '<p>Diese Cookies sind für den Betrieb unserer Websites technisch notwendig und immer aktiviert. Hierzu zählen z.B. sogenannte Session-Cookies, die nach Ende Ihres Besuchs automatisch gelöscht werden.</p>',
        en: '<p>These cookies are technically necessary for the operation of our websites and are always activated. These include, for example, so-called session cookies, which are automatically deleted at the end of your visit.</p>',
      },
      type: 'required',
      showInInfoPanel: true,
    },
    {
      name: {
        de: 'Matomo',
        en: 'Matomo',
      },
      text: {
        de: `<p>Mit Hilfe der Matomo Cookies erheben wir statistische Daten über die Nutzung unserer Webseiten. Die Analyse dieser Daten ermöglicht es uns, unser Webangebot für Sie weiterzuentwickeln und ständig zu verbessern. Sämtliche Daten für Statistiken und Analysen erfassen wir anonymisiert, dazu wird u.a. Ihre IP-Adresse verfremdet.</p>
      <p><strong>Sie können Ihre Cookie-Einstellungen jederzeit ändern und die Änderung durch erneutes Laden der Internetseite aktivieren.</strong></p>`,
        en: `<p>With the help of Matomo cookies, we collect statistical data about the use of our websites. The analysis of this data enables us to further develop and constantly improve our website for you. We collect all data for statistics and analyses anonymously; for this purpose, among other things, your IP address is obscured.</p>
      <p><strong>You can modify your cookie settings at any time and activate the changes by reloading the website.</strong></p>`,
      },
      type: 'tracking',
      showInInfoPanel: true,
      trackingScripts: [
        {
          insertSelector: 'body',
          script:
            'var _paq = window._paq = window._paq || [];\n' +
            "_paq.push(['trackPageView']);\n" +
            "_paq.push(['enableLinkTracking']);\n" +
            '(function() {\n' +
            `var u="${matomoUrl}";\n` +
            "_paq.push(['setTrackerUrl', u+'matomo.php']);\n" +
            `_paq.push(['setSiteId', '${matomoSiteId}']);\n` +
            "var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];\n" +
            "g.type='text/javascript'; g.async=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);\n" +
            '})();',
        },
      ],
    },
  ],
  onRender: banner => {
    const infoPanelAccordions = $$('.cookiebanner__info-panel li', banner);
    infoPanelAccordions.length &&
      infoPanelAccordions.forEach(accordion => {
        const randomID = uniqueId();
        const target = $('.cookiebanner__shower-panel', accordion);
        const handler = $('button', accordion);

        setAttributes(handler, {
          id: `acc-btn-${randomID}`,
          'aria-controls': `acc-tab-${randomID}`,
        });

        setAttributes(target, {
          id: `acc-tab-${randomID}`,
          'aria-labelledby': `acc-btn-${randomID}`,
        });

        new Accordion({
          target,
          targetInner: $('.cookiebanner__shower-panel-inner', target),
          handler,
          easing: 'easeInOutQuart',
          duration: 400,
          initOpened: false,
        }).init();
      });
  },
}).init();
// }

// TODO: check if the trackingScripts are correct (Ronny)
